export default
{
    emits:
    [
        'open',
        'close',
        'update:modelValue',
        'search',
        'search:compositionstart',
        'search:compositionend',
        'search:keydown',
        'search:blur',
        'search:focus',
        'search:input',
        'option:created',
        'option:selecting',
        'option:selected',
        'option:deselecting',
        'option:deselected'
    ]
}